<template>
  <div class="q-mx-auto q-pa-sm">
    <q-card flat>
      <div class="q-pb-xs">
        <StockAlphaBeta :symbol="selectedSymbol" :theme="theme" />
      </div>
      <div class="row">
        <div class="col-md-4 col-12 q-mt-xs">
          <StockWiseEssentialStatistics
            class="q-mb-sm"
            :symbol="selectedSymbol"
            :theme="theme"
          />
          <TechnicalStatus
            v-if="selectedSymbol"
            :trendFilterData="trendFilterData[0]"
          ></TechnicalStatus>

          <q-card flat bordered class="q-mt-xs">
            <DisclaimerMessage short v-if="theme == false" />
          </q-card>
        </div>
        <div class="col-md-8 col-12 q-pl-md-sm q-mt-xs">
          <TradingViewMini
            class="q-mb-sm"
            :symbol="selectedSymbol"
            :enableDailyWeeklyIntraday="true"
            @changeActiveSymbol="changeSelectedSymbol($event)"
            :theme="theme"
            :signalTypedata="signalTypeData"
            :isSignalType="isSignalType"
            :indicators="indicators"
            :signaltype="signalType"
            :alertOrSignal="alertOrSignal"
            :timePeriod="timePeriod"
          />
          <div
            v-if="
              store.state.authenticate.isAuthenticated && packageDetail !== null
            "
          >
            <StockWiseChukulPerformance
              v-if="selectedSymbol"
              class="q-my-md"
              :searchStock="selectedSymbol"
              :key="selectedSymbol"
            />
            <ConfirmSignal class="q-my-sm" :symbol="selectedSymbol" />
          </div>

          <q-card flat bordered class="q-py-sm">
            <StockWiseAreaChart
              :chartHeight="$q.screen.gt.xs ? 305 : 305"
              :symbol="selectedSymbol"
            />
          </q-card>

          <q-card
            flat
            bordered
            class="q-my-sm q-pa-xs"
            v-if="
              store.state.packages.packageStatus?.current_package
                .package_name === 'Platinum'
            "
          >
            <StockWiseAreaChartMarketDepth
              :chartHeight="$q.screen.gt.xs ? 305 : 305"
              :symbol="selectedSymbol"
            />
          </q-card>

          <Speedometer :symbol="selectedSymbol" class="q-mt-sm" />
        </div>
      </div>
    </q-card>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import Speedometer from "src/components/SpeedoMeter.vue";
import StockAlphaBeta from "src/components/StockAlphaBeta.vue";
import TradingViewMini from "src/components/Tradingview/TradingViewMini.vue";
import DisclaimerMessage from "src/components/DisclaimerMessage.vue";
import TechnicalStatus from "src/components/TechnicalStatus";
import ConfirmSignal from "src/components/signalTable/ConfirmSignal.vue";
import StockWiseEssentialStatistics from "src/components/StockWiseEssentialStatistics.vue";
import StockWiseChukulPerformance from "src/components/StockWiseChukulPerformance.vue";
import StockWiseAreaChart from "src/components/StockProfile/StockWiseAreaChart.vue";
import StockWiseAreaChartMarketDepth from "src/components/StockProfile/StockWiseAreaChartMarketDepth.vue";
import useData from "src/use/data";

const props = defineProps({
  theme: {
    type: Boolean,
    default: false,
  },
  symbol: {
    type: String,
    required: true,
  },
  isSignalType: {
    type: Boolean,
    default: () => false,
  },
  signalTypeData: {
    type: Array,
    default: () => [],
  },
  indicators: {
    type: Array,
  },
  signalType: {
    type: String,
  },
  alertOrSignal: {
    type: String,
  },
  timePeriod: {
    type: String,
    default: () => "daily",
  },
});

const $q = useQuasar();
const { filterTrend } = useData();
let selectedSymbol = ref(props.symbol);
const store = useStore();
const asOf = ref(null);
const trendFilterData = ref([]);
const packageDetail = ref({});

function changeSelectedSymbol(e) {
  selectedSymbol.value = e;
}
const gettrendFilterData = () => {
  let payload = {
    date: asOf.value,
    symbol: props.symbol,
  };
  filterTrend(payload)
    .then((res) => {
      trendFilterData.value = res.data;
    })
    .catch((error) => {
      const { data, status } = error.response;
      if (status == 500) {
        console.error(data);
      }
    });
};
const getAsof = async () => {
  if (store.state.market.asOf) {
    asOf.value = store.state.market.asOf;
    gettrendFilterData();
  } else {
    await store.dispatch("market/marketStatusNew");
    asOf.value = store.state.market.asOf;
    gettrendFilterData();
  }
};

watch(
  () => props.symbol,
  (newVal, oldVal) => {
    selectedSymbol.value = newVal;
    if (asOf.value) gettrendFilterData();
  }
);

onMounted(async () => {
  if (store.state.authenticate.isAuthenticated) {
    await store.dispatch("packages/getPackageStatus");
    packageDetail.value = store.state.packages.packageStatus;
  }

  getAsof();
});
</script>
